/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The status of a job step.  - `JOB_STEP_STATUS_UNSPECIFIED`: Status is not specified. - `PENDING`: Step is valid but hasn\'t started yet. - `RUNNING`: Step is currently running. - `COMPLETED`: Step completed successfully. - `FAILED`: Step failed. 
*/
export enum JobStepStatus {
  JOB_STEP_STATUS_UNSPECIFIED = 'JOB_STEP_STATUS_UNSPECIFIED',
  JOB_STEP_STATUS_PENDING = 'PENDING',
  JOB_STEP_STATUS_RUNNING = 'RUNNING',
  JOB_STEP_STATUS_COMPLETED = 'COMPLETED',
  JOB_STEP_STATUS_FAILED = 'FAILED'
}
